type Pattern<T> = Partial<T>;
type Matcher<T, R> = {
  pattern?: Pattern<T>;
  predicate?: (data: T) => boolean;
  callback: () => R;
};

export const match = <T, R>(data: T) => {
  const cases: Array<Matcher<T, R>> = [];

  return {
    with(pattern: Pattern<T>, callback: () => R) {
      cases.push({ pattern, callback });

      return this;
    },
    when(predicate: (data: T) => boolean, callback: () => R) {
      cases.push({ predicate, callback });

      return this;
    },
    otherwise(callback: () => R): R {
      for (const { pattern, predicate, callback: caseCallback } of cases) {
        if (
          pattern &&
          Object.entries(pattern).every(
            ([key, val]) => (data as any)[key] === val, // eslint-disable-line
          )
        ) {
          return caseCallback();
        }
        if (predicate && predicate(data)) {
          return caseCallback();
        }
      }

      return callback();
    },
  };
};
